var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l(([
      _vm.SurveyType.Feedback,
      _vm.SurveyType.HowDidYouFindOut,
    ].filter((type) => _vm.shouldDisplaySurvey(type))),function(dialogType){return _c('SurveyDialog',{key:dialogType,attrs:{"is-open":_vm.dialogQueue[0] === dialogType,"user":_vm.user,"on-close":_vm.handleClose,"type":dialogType}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }